import {Serializers} from "../../interfaces/serializer";
import {SavedReport} from "../../interfaces/saved-reports";
import {SavedReportComponentObjects} from "../../classes/saved-report-component-object";

export const SAVED_REPORTS_STATE_NAME = 'savedReports';

export interface SavedReportsState {
  serialized: Serializers<SavedReport>;
  componentObjects: SavedReportComponentObjects;
  favoriteReports: Serializers<SavedReport>;
  included: any;
  loading: boolean;
  loaded: boolean;
  initialized: boolean;
}
